const baseInput = $('<input style="position:absolute;bottom:0;left:0;width:0px;height:0px" />');

// Hack to force iPhone to show keyboard when displaying new input field using select2
export default (container) => {
  if (/(iPod|iPhone)/.test(navigator.userAgent)) {
    $(container).on('click', () => {
      const input = baseInput.clone().appendTo('body').focus();
      setTimeout(() => input.remove(), 50);
    });
  }
};
